<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1080 1080"
  [innerHTML]="svgContent()">
</svg>
